import { Turbo } from "@hotwired/turbo-rails";

function modalAction(action) {
  return function() {
    $(`#${this.getAttribute("target")}`).modal(action);
  };
}

Turbo.StreamActions.show_modal = modalAction("show");
Turbo.StreamActions.hide_modal = modalAction("hide");
Turbo.StreamActions.dispose_modal = modalAction("dispose");
